import React from 'react'
import PropTypes from 'prop-types'
import styles from './Tabs.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

export const Tabs = ({ label, value, onChange, items, className }) => {
  const refs = React.useRef([])

  const onKeyDown = e => {
    const i = items.findIndex(t => t.value === value)
    let next = null
    if (e.key === 'ArrowRight') next = (i + 1) % items.length
    else if (e.key === 'ArrowLeft') next = (i - 1 + items.length) % items.length
    else if (e.key === 'Home') next = 0
    else if (e.key === 'End') next = items.length - 1
    if (next === null) return
    e.preventDefault()
    onChange(items[next].value)
    const el = refs.current[next]
    if (el) el.focus()
  }

  return (
    <div role="tablist" aria-label={label} className={cx(styles.tablist, className)} onKeyDown={onKeyDown}>
      {items.map((t, i) => {
        const selected = t.value === value
        return (
          <button
            key={t.value}
            ref={el => { refs.current[i] = el }}
            type="button"
            role="tab"
            id={`tab-${t.value}`}
            aria-selected={selected}
            aria-controls={t.panelId}
            tabIndex={selected ? 0 : -1}
            className={styles.tab}
            onClick={() => onChange(t.value)}
          >
            {t.label}
            {typeof t.count === 'number' && <span className={styles.count}>{t.count}</span>}
          </button>
        )
      })}
    </div>
  )
}

Tabs.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    count: PropTypes.number,
    panelId: PropTypes.string,
  })).isRequired,
  className: PropTypes.string,
}

export const SegmentedControl = ({ label, value, onChange, items, className }) => (
  <div role="radiogroup" aria-label={label} className={cx(styles.segmented, className)}>
    {items.map(o => (
      <button
        key={o.value}
        type="button"
        role="radio"
        aria-checked={o.value === value}
        className={styles.segment}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
)

SegmentedControl.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })).isRequired,
  className: PropTypes.string,
}

export default Tabs
